import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import ProductcompositionFilterCriteria from './ProductcompositionFilterCriteria'
import ProductcompositionList from './ProductcompositionList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './ProductcompositionAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setProductcompositionDashboardProductcompositionList } from '../../store/slice/PharmaSlice';

export default function ProductcompositionListView({setShowEdit,setProductcompositionId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.productcompositionDashboard);   

    const [filteredProductcompositionList, setFilteredProductcompositionList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { productcompositionDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (productcompositionDashboard.productcompositionList.length>-1){
        setFilteredProductcompositionList(productcompositionDashboard.productcompositionList);
        transformToCardFormat(productcompositionDashboard.productcompositionList, setCardList);
      }
    },[productcompositionDashboard.productcompositionList])

    useEffect(()=>{
          transformToCardFormat(filteredProductcompositionList, setCardList);
      },[filteredProductcompositionList])

    useEffect(()=>{
        if (filterCriteria.compositionname==='' && filterCriteria.compositionid==='' && filterCriteria.quantity==='' ){
            setFilteredProductcompositionList(productcompositionDashboard.productcompositionList);
            transformToCardFormat(productcompositionDashboard.productcompositionList, setCardList);

        } else {
            setFilteredProductcompositionList(
                productcompositionDashboard.productcompositionList
                    .filter(productcomposition=> productcomposition.compositionname.toString().toUpperCase().includes(filterCriteria.compositionname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(productcompositionDashboard.filteredProductcompositionList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <ProductcompositionList
                    setShowEdit={setShowEdit}
                    setProductcompositionId = {setProductcompositionId}
                    tableList={filteredProductcompositionList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}